import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { Store } from "@ngxs/store";

import { VehicleGetterState } from "../../ngxs/vehicle";
import { Vehicle } from "../models";
import { IRequestsNestedState } from "../../ngxs/interfaces/requests.interface";
import { LoadCustomerVehiclesAction } from "../../ngxs/vehicle/vehicle.actions";

@Injectable({
  providedIn: "root",
})
export class VehicleService {
  customerVehicles$: Observable<Vehicle[]> = this.store.select(
    VehicleGetterState.getCustomerVehicles
  );
  customerVehiclesWithCostCentreName$: Observable<
    Array<Vehicle & { costCentreName: string }>
  > = this.store.select(
    VehicleGetterState.getCustomerVehiclesWithCostCentreName
  );
  inactiveVehicles$: Observable<Vehicle[]> = this.store.select(
    VehicleGetterState.getInactiveCustomerVehicles
  );
  customerVehiclesRequestState$: Observable<IRequestsNestedState> =
    this.store.select(VehicleGetterState.getCustomerVehiclesRequestState);

  constructor(private store: Store) {}

  loadCustomerVehicles() {
    this.store.dispatch(new LoadCustomerVehiclesAction());
  }
}
